// extracted by mini-css-extract-plugin
export default {"toggleContainer":"ToggleSwitch_toggleContainer__YvZTq","label":"ToggleSwitch_label__90Cwv"};